import React, {Fragment} from 'react';
import {
    Header,
    Grid, Segment, Dropdown, Form
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import RadioQuestionForm from "../../QuestionForms/RadioQuestionForm";
import AnswerQuestionForm from "../../QuestionForms/AnswerQuestionForm";
import SliderQuestionForm from "../../QuestionForms/SliderQuestionForm";
import OfferedAnswerQuestionForm from "../../QuestionForms/OfferedAnswerQuestionForm";
import OfferedMultipleAnswerQuestionForm from "../../QuestionForms/OfferedMultipleAnswerQuestionForm";
import DateQuestionForm from "../../QuestionForms/DateQuestionForm";
import {FormattedMessage} from "react-intl";
import OfferedAnswerQuestionCommentForm from "../../QuestionForms/OfferedAnswerQuestionCommentForm";
import OfferedMultipleAnswerQuestionCommentForm from "../../QuestionForms/showOfferedMultipleAnswerQuestionCommentForm";



export default class CreateQuestion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            questionTypes:[],
            showQuestionForm: false,
            showRadioQuestionForm: true,
            showAnswerQuestionForm: false,
            showDateQuestionForm: false,
            showSliderQuestionForm: false,
            showOfferedAnswerQuestionForm: false,
            showOfferedMultipleAnswerQuestionForm: false,
            type: 'select',
            sections: []

        };
        this.fetchQuestionTypes = this.fetchQuestionTypes.bind(this);
        this.fetchQuestionSections = this.fetchQuestionSections.bind(this);
        this.createQuestion = this.createQuestion.bind(this);

    }
    UNSAFE_componentWillMount() {
     this.fetchQuestionSections(JSON.parse(localStorage.getItem('poll')).pollType)

    }

    componentDidMount() {

        this.fetchQuestionTypes();
    }

    fetchQuestionSections(pollTypeId) {
        axios.get(`/questionnaire/get-sections/${pollTypeId}/`)
            .then(res => {
                const sections = res.data.map(el => ({
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));
                this.setState({ sections });
            })
            .catch(err => {
                console.log('Failed to fetch question sections.');
            });
    }


    fetchQuestionTypes(){
        axios.get('/question/get-types/')
            .then(res => {
                const questionTypes = res.data.map(el => ({
                    value: el.name,
                    key: el.id,
                    text: el.name
                }));
                this.setState({ questionTypes });
            })
            .catch(err => {
                console.log('Failed to fetch poll types.');
            });
    }
    createQuestion(text, section, np = false,scaleFrom = null, scaleTo= null, questionOptions = []){

        let obj = {
            questionnaire: {id: JSON.parse(localStorage.getItem('poll')).pollId, questionnaireStatus: {id:JSON.parse(localStorage.getItem('poll')).pollStatus}},
            question: {
                text: text,
                cannotRate: np ,
                defaultQuestion: false,
                section: {id: section},
                scaleFrom: scaleFrom,
                scaleTo: scaleTo,
                questionType: {id: this.state.questionTypes.find(e =>e.value===this.state.type).key},


            },
            questionOptions: questionOptions


        };
        axios.post('question/create/', { ...obj })
            .then(res => {
                toast('Uspješno ste kreirali pitanje.')
                this.resetForm()
            })
            .catch(err => {
                toast('Došlo je do greške.')
                console.log('Failed to create question.');
            });
    }
    resetForm(){
        this.setState({
            type: 'select',
            showRadioQuestionForm: false,
            showAnswerQuestionForm: false,
            showDateQuestionForm: false,
            showSliderQuestionForm: false,
            showOfferedAnswerQuestionForm: false,
            showOfferedAnswerQuestionCommentForm: false,
            showOfferedMultipleAnswerQuestionCommentForm: false,
            showOfferedMultipleAnswerQuestionForm: false
        },()=>{this.setState({showRadioQuestionForm: true})})
    }

    handleChange=(e, { value }) =>{
        if (value === 'select') {
            this.setState({
                type: value,
                showRadioQuestionForm: true,
                showDateQuestionForm: false,
                showAnswerQuestionForm: false,
                showSliderQuestionForm: false,
                showOfferedAnswerQuestionCommentForm: false,
                showOfferedMultipleAnswerQuestionForm: false,
                showOfferedMultipleAnswerQuestionCommentForm: false,
                showOfferedAnswerQuestionForm: false
            });
        } else if (value === 'tekst') {
            //console.log('type:',e);
            this.setState({
                type: value,
                showAnswerQuestionForm: true,
                showDateQuestionForm: false,
                showRadioQuestionForm: false,
                showSliderQuestionForm: false,
                showOfferedAnswerQuestionCommentForm: false,
                showOfferedMultipleAnswerQuestionForm: false,
                showOfferedMultipleAnswerQuestionCommentForm: false,
                showOfferedAnswerQuestionForm: false
            });
        } else if (value === 'slajder') {
            this.setState({
                type: value,
                showSliderQuestionForm: true,
                showDateQuestionForm: false,
                showRadioQuestionForm: false,
                showAnswerQuestionForm: false,
                showOfferedAnswerQuestionCommentForm: false,
                showOfferedMultipleAnswerQuestionForm: false,
                showOfferedMultipleAnswerQuestionCommentForm: false,
                showOfferedAnswerQuestionForm: false
            });
        } else if (value === 'jedan odgovor') {
            this.setState({
                type: value,
                showOfferedAnswerQuestionForm: true,
                showDateQuestionForm: false,
                showRadioQuestionForm: false,
                showAnswerQuestionForm: false,
                showOfferedAnswerQuestionCommentForm: false,
                showOfferedMultipleAnswerQuestionForm: false,
                showOfferedMultipleAnswerQuestionCommentForm: false,
                showSliderQuestionForm: false
            });
        } else if (value === 'više odgovora') {
            this.setState({
                type: value,
                showOfferedMultipleAnswerQuestionForm: true,
                showOfferedAnswerQuestionForm: false,
                showDateQuestionForm: false,
                showRadioQuestionForm: false,
                showAnswerQuestionForm: false,
                showOfferedAnswerQuestionCommentForm: false,
                showOfferedMultipleAnswerQuestionCommentForm: false,
                showSliderQuestionForm: false
            });
        }else if (value === 'datum') {
            this.setState({
                type: value,
                showDateQuestionForm: true,
                showOfferedMultipleAnswerQuestionForm: false,
                showOfferedAnswerQuestionForm: false,
                showRadioQuestionForm: false,
                showAnswerQuestionForm: false,
                showOfferedAnswerQuestionCommentForm: false,
                showOfferedMultipleAnswerQuestionCommentForm: false,
                showSliderQuestionForm: false
            });
        }else if (value === 'jedan odgovor sa komentarom') {
            this.setState({
                type: value,
                showDateQuestionForm: false,
                showOfferedMultipleAnswerQuestionForm: false,
                showOfferedAnswerQuestionForm: false,
                showRadioQuestionForm: false,
                showAnswerQuestionForm: false,
                showOfferedAnswerQuestionCommentForm: true,
                showOfferedMultipleAnswerQuestionCommentForm: false,
                showSliderQuestionForm: false
            });
        }else if (value === 'više odgovora sa komentarom') {
            this.setState({
                type: value,
                showDateQuestionForm: false,
                showOfferedMultipleAnswerQuestionForm: false,
                showOfferedAnswerQuestionForm: false,
                showRadioQuestionForm: false,
                showAnswerQuestionForm: false,
                showOfferedAnswerQuestionCommentForm: false,
                showOfferedMultipleAnswerQuestionCommentForm: true,
                showSliderQuestionForm: false
            });
        }
    }

    render() {
        const {questionTypes}=this.state;
        return (

                <Fragment>

                        <Form>
                            <Form.Field width={4}>
                                <label>
                                   Tip odgovora
                                </label>
                                <Form.Dropdown
                                    clearable
                                    placeholder="Odaberite tip"
                                    value={this.state.type}
                                    onChange={this.handleChange}
                                    name="type"
                                    options={questionTypes}
                                    search
                                    selection
                                    required
                                    error={this.state.sectionErr}
                                />
                            </Form.Field>
                        </Form>

                        <hr/>

                    {this.state.showRadioQuestionForm &&

                    <RadioQuestionForm
                        sections={this.state.sections}
                        closeQuestionForm={this.closeQuestionForm}
                        createQuestion={this.createQuestion}
                    />
                    }
                    { this.state.showAnswerQuestionForm &&

                    <AnswerQuestionForm
                        sections={this.state.sections}
                        closeQuestionForm={this.closeQuestionForm}
                        createQuestion={this.createQuestion}
                    />
                    }
                    { this.state.showSliderQuestionForm &&

                    <SliderQuestionForm
                        sections={this.state.sections}
                        closeQuestionForm={this.closeQuestionForm}
                        createQuestion={this.createQuestion}
                    />
                    }
                    { this.state.showOfferedAnswerQuestionForm &&

                    <OfferedAnswerQuestionForm
                        sections={this.state.sections}
                        closeQuestionForm={this.closeQuestionForm}
                        createQuestion={this.createQuestion}
                    />
                    }
                    { this.state.showOfferedAnswerQuestionCommentForm &&

                    <OfferedAnswerQuestionCommentForm
                        sections={this.state.sections}
                        closeQuestionForm={this.closeQuestionForm}
                        createQuestion={this.createQuestion}
                    />
                    }
                    {this.state.showOfferedMultipleAnswerQuestionForm &&

                    <OfferedMultipleAnswerQuestionForm
                        sections={this.state.sections}
                        closeQuestionForm={this.closeQuestionForm}
                        createQuestion={this.createQuestion}
                    />
                    }
                    {this.state.showOfferedMultipleAnswerQuestionCommentForm &&

                    <OfferedMultipleAnswerQuestionCommentForm
                        sections={this.state.sections}
                        closeQuestionForm={this.closeQuestionForm}
                        createQuestion={this.createQuestion}
                    />
                    }
                    {this.state.showDateQuestionForm &&

                    <DateQuestionForm
                        sections={this.state.sections}
                        closeQuestionForm={this.closeQuestionForm}
                        createQuestion={this.createQuestion}
                    />
                    }
                    <ToastContainer hideProgressBar />
                </Fragment>



        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/PollPreviewTabs/CreateQuestion/CreateQuestion.js